


import { setGetMailingStatisticsScrollerUsersWithdrawalsAction } from '../action';
import { getMailingStatisticsScrollerUsersWithdrawals } from '../api/getMailingStatisticsScrollerUsersWithdrawals';

export const setGetMailingStatisticsScrollerUsersWithdrawals = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersWithdrawals(params);

            dispatch(setGetMailingStatisticsScrollerUsersWithdrawalsAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}